import React, { useContext} from 'react';
import ListView from "../../../shared/components/ListView";
import { MaterialRow } from "./CustomerTable";
import { MaterialTableColumns, Search } from "../../../configs/material";
import { MaterialSortTypes } from "../../../configs/sortTypes";
import { MaterialFilterType } from "../../../configs/filterTypes";
import { AuthenticationContext } from '../../../provider/AuthenticationProvider';
import { ROLE } from '../../../data/enums';

const Content = () => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getTableColumns = () => {
        const hiddenKeys = new Set<string>();
        if ([ROLE.FIRST_STORAGE_KEEPER, ROLE.SECOND_STORAGE_KEEPER].includes(role)) {
            hiddenKeys.add("storage");
        }
        return MaterialTableColumns.filter((column) => !hiddenKeys.has(column.key));
    };
    return (
        <ListView
            url="/materials/"
            sortTypes={MaterialSortTypes}
            filterTypes={MaterialFilterType}
            rowElement={MaterialRow}
            tableColumns={getTableColumns()}
            textString={Search.searchText}
        />
    );
};

export default Content;
